export { SearchDialog_component_default as SearchDialog, SearchEmptyState_component_default as SearchEmptyState, SearchInput_component_default as SearchInput, SearchList_component_default as SearchList, SearchTitle_component_default as SearchTitle } from './chunk-QQ23VFRA.js';
export { SearchableSelect_default as SearchableSelect } from './chunk-7HH2OI54.js';
export { Select_default as Select } from './chunk-2Z3VQCLJ.js';
import { scoreText } from './chunk-CRHCAN44.js';
export { ORG_AVATAR_BGCOLOR, Sidebar_component_default as Sidebar, SidebarCategoryTab_component_default as SidebarCategoryTab, Sidebar_component_default as SidebarComponent, SidebarDrawer_component_default as SidebarDrawer, SidebarHeader_component_default as SidebarHeader, SidebarLink_component_default as SidebarLink, SidebarOrgHeader_component_default as SidebarOrgHeader, SidebarRouteList_component_default as SidebarRouteList, SidebarSearch_component_default as SidebarSearch, SidebarSubNav_component_default as SidebarSubNav, SidebarToggleButton_component_default as SidebarToggleButton, calculateFuzzyScore, getIconValue, matchesSearch, scoreText } from './chunk-CRHCAN44.js';
export { IosSwitch_default as IosSwitch, Switch_default as Switch, Switch as SwitchComponent } from './chunk-ZWSDGAPK.js';
export { Timeline_default as Timeline, Timeline as TimelineComponent } from './chunk-CBFZIZMV.js';
export { Topbar_default as Topbar, TopbarComponent } from './chunk-V3X2FFYB.js';
export { DRAWER_WIDTH } from './chunk-CUKHRH2F.js';
export { CollapsableComp_default as CollapsableComp, CustomMaterialTable, CustomMaterialTableComp_default as CustomMaterialTableComp, CustomMaterialTableRow, ExportTableComp, PaginationTableComp_default as PaginationTableComp, SearchTableComp, SortByComp, TableButton_default as TableButton } from './chunk-GMBD7EOR.js';
export { DialogWithImage_default as DialogWithImage } from './chunk-VWAQ5GJM.js';
export { Drawer_default as Drawer } from './chunk-IPTW4GUQ.js';
import { weekDayLabels, dateInRange, CalendarRangeComp_default, getLastMonthRange, QuickSelect_default } from './chunk-DYLHTSF4.js';
export { CurrencyInput_default as CurrencyInput, DatePicker_default as DatePicker, DatePickerInput_default as DatePickerInput, DateRangePicker_default as DateRangePicker, FormFlow_default as FormFlow, FormStepType, MappingButton_default as MappingButton, PercentageSlider_default as PercentageSlider, SingleSelectInput_default as SingleSelectInput } from './chunk-DYLHTSF4.js';
export { StyledTab_default as StyledTab, StyledTabs_default as StyledTabs } from './chunk-NOJ74DUO.js';
import { SingleSelect_default, ApplyCancel_default, pluralize } from './chunk-6UBOFWLJ.js';
export { MultiSelect_default as MultiSelect, SingleSelect_default as SingleSelect, SplitSelect_default as SplitSelect } from './chunk-6UBOFWLJ.js';
export { LoopChat_default as LoopChat } from './chunk-RSFNTQIX.js';
export { Paper_default as Paper, Paper as PaperComponent } from './chunk-FLDWG2L5.js';
export { AgentChat_default as AgentChat } from './chunk-Q4W7JRTM.js';
import './chunk-KYEWUKP7.js';
export { Alert_default as Alert } from './chunk-QFJTOHOK.js';
export { AutoComplete_default as AutoComplete } from './chunk-PKGGZBAD.js';
export { TypoWithCopy } from './chunk-NGRX6DO6.js';
export { DeltaCard_default as Card } from './chunk-37MRVOO5.js';
export { CustomTypoContainer, StyledTypo_default as Typo, TypoContainer } from './chunk-MYGKM72Z.js';
export { AreaChart_default as AreaChart, BarChart_default as BarChart, ComposedChart_default as ComposedChart, LineChart_default as LineChart, PieChart_default as PieChart, ScatterChart_default as ScatterChart } from './chunk-XYDIJYBT.js';
export { Container_default as Container } from './chunk-LQDCMT4L.js';
import { ErrorBoundary_default } from './chunk-NJFJDBQA.js';
import { ThemeProvider, defaultTheme_default } from './chunk-J2FXRRBJ.js';
export { defaultTheme_default as theme } from './chunk-J2FXRRBJ.js';
import { __spreadValues, __spreadProps } from './chunk-2FEJBM4N.js';
import { Box, Stack, Skeleton, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, InputLabel, useMediaQuery, Popover, Divider } from '@mui/material';
import React7, { useCallback, useEffect, useMemo } from 'react';
import { Controller, get } from 'react-hook-form';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment2 from 'moment';
import { Calendar, DateObject } from 'react-multi-date-picker';
import { get as get$1 } from 'lodash';

var AggregateCard = (props) => {
  const {
    title,
    description,
    value,
    icon,
    topRightComp,
    bottomComp,
    loading,
    width,
    cardSx,
    titleSx,
    valueSx,
    descriptionSx
  } = props;
  return /* @__PURE__ */ React7.createElement(ErrorBoundary_default, { componentName: "AggregateCard" }, /* @__PURE__ */ React7.createElement(ThemeProvider, null, /* @__PURE__ */ React7.createElement(
    Box,
    {
      sx: {
        bgcolor: "white",
        borderRadius: "4px",
        border: "1px solid rgba(230, 230, 230, 1)",
        width: width || "100%"
      }
    },
    /* @__PURE__ */ React7.createElement(
      Box,
      {
        sx: __spreadValues({
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          alignItems: "stretch",
          padding: "20px",
          paddingBottom: bottomComp ? "10px" : "20px",
          height: "100%",
          boxSizing: "border-box"
        }, cardSx)
      },
      (icon || topRightComp) && /* @__PURE__ */ React7.createElement(Stack, { direction: "row", alignItems: "flex-start" }, loading ? /* @__PURE__ */ React7.createElement(Skeleton, { variant: "circular", width: 30, height: 30 }) : icon, /* @__PURE__ */ React7.createElement(Box, { sx: { flex: 1 } }), topRightComp && /* @__PURE__ */ React7.createElement(Box, null, topRightComp)),
      /* @__PURE__ */ React7.createElement(
        Box,
        {
          sx: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: "10px"
          }
        },
        title && /* @__PURE__ */ React7.createElement(Box, null, loading ? /* @__PURE__ */ React7.createElement(Skeleton, { variant: "rounded", width: "50%", height: 24 }) : /* @__PURE__ */ React7.createElement(
          Typography,
          {
            variant: "h6",
            sx: __spreadValues({
              fontSize: "14px",
              fontWeight: 600
            }, titleSx)
          },
          title
        )),
        value && (loading ? /* @__PURE__ */ React7.createElement(Skeleton, { variant: "rounded", width: "75%", height: 36 }) : /* @__PURE__ */ React7.createElement(
          Typography,
          {
            variant: "h5",
            sx: __spreadValues({
              fontSize: "32px",
              fontWeight: 600
            }, valueSx)
          },
          value
        ))
      ),
      description && (loading ? /* @__PURE__ */ React7.createElement(
        Box,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            gap: "5px"
          }
        },
        /* @__PURE__ */ React7.createElement(Skeleton, { variant: "rounded", width: "100%", height: 14 }),
        /* @__PURE__ */ React7.createElement(Skeleton, { variant: "rounded", width: "30%", height: 14 })
      ) : /* @__PURE__ */ React7.createElement(
        Typography,
        {
          variant: "subtitle2",
          color: "rgba(0, 0, 0, 0.5)",
          sx: descriptionSx
        },
        description
      ))
    ),
    bottomComp && /* @__PURE__ */ React7.createElement(Box, null, bottomComp)
  )));
};
var AggregateCard_default = AggregateCard;
var TimePicker = (props) => {
  const { showOptionsIn24Hour, minutesStep = 15, value, onChange } = props;
  const options = React7.useMemo(() => {
    const options2 = [];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += minutesStep) {
        const hourLabel = showOptionsIn24Hour ? i.toString().padStart(2, "0") : i % 12 || 12;
        const minute = j.toString().padStart(2, "0");
        const timeLabel = `${hourLabel}:${minute}${showOptionsIn24Hour ? "" : i < 12 ? " am" : " pm"}`;
        const timeValue = `${i.toString().padStart(2, "0")}:${minute}:00`;
        options2.push({
          label: timeLabel,
          value: timeValue
        });
      }
    }
    return options2;
  }, [showOptionsIn24Hour, minutesStep]);
  return /* @__PURE__ */ React7.createElement(ErrorBoundary_default, { componentName: "TimePicker" }, /* @__PURE__ */ React7.createElement(ThemeProvider, null, /* @__PURE__ */ React7.createElement(
    SingleSelect_default,
    {
      options,
      value,
      onChange: (value2) => onChange(value2),
      disableSearch: true,
      disableSort: true,
      menuItemSx: {
        fontVariantNumeric: "tabular-nums"
      },
      menuWidth: 120,
      renderValue: value === void 0 ? () => {
        if (value === void 0)
          return /* @__PURE__ */ React7.createElement(Typography, { fontSize: 12, color: "#000" }, "Select time");
      } : void 0
    }
  )));
};
var TimePicker_default = TimePicker;
var ConfirmDialog = (props) => {
  const {
    open,
    title,
    description,
    extraDescription,
    handleCancel,
    handleConfirm,
    confirmText
  } = props;
  const [inputText, setInputText] = React7.useState("");
  const valid = React7.useMemo(() => {
    if (!confirmText) return true;
    return inputText === confirmText;
  }, [inputText, confirmText]);
  React7.useEffect(() => {
    if (!open) setInputText("");
  }, [open]);
  return /* @__PURE__ */ React7.createElement(ErrorBoundary_default, { componentName: "ConfirmDialog" }, /* @__PURE__ */ React7.createElement(ThemeProvider, null, /* @__PURE__ */ React7.createElement(
    Dialog,
    {
      open,
      maxWidth: "sm",
      sx: {
        "& .MuiDialogTitle-root": {
          paddingTop: "24px"
        },
        "& .MuiDialogActions-root": {
          paddingX: "24px",
          paddingY: "24px"
        }
      }
    },
    /* @__PURE__ */ React7.createElement(DialogTitle, null, title),
    /* @__PURE__ */ React7.createElement(DialogContent, null, description && /* @__PURE__ */ React7.createElement(DialogContentText, null, description), extraDescription, confirmText && /* @__PURE__ */ React7.createElement(
      Box,
      {
        sx: {
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          width: "100%",
          mt: "16px"
        }
      },
      /* @__PURE__ */ React7.createElement(Typography, null, "Type this text in the input box below."),
      /* @__PURE__ */ React7.createElement(
        Typography,
        {
          sx: {
            background: "lightgray",
            borderRadius: "2px",
            paddingX: "8px",
            paddingY: "4px",
            display: "inline-block",
            margin: 0,
            fontFamily: "monospace",
            fontSize: "14px"
          }
        },
        confirmText
      ),
      /* @__PURE__ */ React7.createElement(
        TextField,
        {
          fullWidth: true,
          value: inputText,
          onChange: (e) => setInputText(e.target.value),
          placeholder: "Type the text here to confirm",
          "data-testid": "confirmDialog-text-input"
        }
      )
    )),
    /* @__PURE__ */ React7.createElement(DialogActions, null, /* @__PURE__ */ React7.createElement(
      Button,
      {
        variant: "text",
        onClick: () => {
          handleCancel();
        },
        sx: { mr: 1, px: "22px" },
        "data-testid": "confirmDialog-cancel-btn"
      },
      "Cancel"
    ), /* @__PURE__ */ React7.createElement(
      Button,
      {
        disabled: !valid,
        variant: "contained",
        onClick: () => {
          handleConfirm();
        },
        "data-testid": "confirmDialog-confirm-btn"
      },
      "Confirm"
    ))
  )));
};
var ConfirmDialog_default = ConfirmDialog;
function ControlledTextField(props) {
  const {
    control,
    containerBoxSx,
    name,
    showExternalLabel,
    textFieldProps = {},
    rules = {}
  } = props;
  const { label } = textFieldProps;
  return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(ThemeProvider, null, /* @__PURE__ */ React7.createElement(
    Controller,
    {
      control,
      name,
      rules,
      render: ({ field: { value, onChange }, fieldState: { error } }) => {
        return /* @__PURE__ */ React7.createElement(Box, { sx: containerBoxSx }, showExternalLabel && /* @__PURE__ */ React7.createElement(
          InputLabel,
          {
            htmlFor: `${name}-text-field`,
            sx: { fontSize: "12px" }
          },
          label,
          " ",
          /* @__PURE__ */ React7.createElement("span", { style: { color: "red" } }, rules.required && "*")
        ), /* @__PURE__ */ React7.createElement(
          TextField,
          __spreadProps(__spreadValues({}, textFieldProps), {
            id: `${name}-text-field`,
            label: !showExternalLabel ? label : void 0,
            value,
            onChange,
            error: !!get(error, `message`),
            helperText: get(error, `message`)
          })
        ));
      }
    }
  )));
}
function MonthPicker(props) {
  const {
    value: propsValue,
    onChange,
    disabled,
    minDate,
    maxDate,
    renderValue,
    label,
    showClearButton,
    rootButtonSx,
    disableScrollLock
  } = props;
  const [anchorEl, setAnchorEl] = React7.useState(null);
  const [value, setValue] = React7.useState(propsValue || null);
  const isMobile = useMediaQuery(defaultTheme_default.breakpoints.down("sm"));
  React7.useEffect(() => {
    setValue(propsValue);
  }, [propsValue]);
  const showApplyBtn = React7.useMemo(() => {
    if (!value) return false;
    if (!propsValue) return true;
    return !value.isSame(propsValue, "month");
  }, [value, propsValue]);
  const handleMonthChange = (newDate) => {
    if (Array.isArray(newDate) && newDate.length > 0) {
      setValue(moment2(newDate[0].format("YYYY-MM-DD")));
    } else if (!Array.isArray(newDate)) {
      setValue(moment2(newDate.format("YYYY-MM-DD")));
    }
  };
  const handleApplyMonth = (type = "apply") => {
    const formattedValue = (value == null ? void 0 : value.startOf("month")) || null;
    onChange(formattedValue, type);
    setAnchorEl(null);
  };
  const handleClear = () => {
    onChange(null, "clear");
    setAnchorEl(null);
  };
  const handleCancel = () => {
    setAnchorEl(null);
    setValue(propsValue);
  };
  return /* @__PURE__ */ React7.createElement(ErrorBoundary_default, { componentName: "MonthPicker" }, /* @__PURE__ */ React7.createElement(ThemeProvider, null, /* @__PURE__ */ React7.createElement(
    Popover,
    {
      id: "month-picker-popover",
      anchorEl,
      open: Boolean(anchorEl),
      onClose: handleCancel,
      marginThreshold: 20,
      disableScrollLock,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React7.createElement(
      Box,
      {
        sx: {
          padding: isMobile ? "8px" : "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          boxSizing: "border-box",
          maxWidth: isMobile ? 282 : 368,
          minWidth: isMobile ? void 0 : 356,
          "& .rmdp-header": {
            marginTop: "0px"
          }
        }
      },
      /* @__PURE__ */ React7.createElement(
        Box,
        {
          sx: {
            "& .rmdp-calendar, & .rmdp-day-picker": {
              p: 0
            },
            "& .rmdp-shadow": {
              boxShadow: "none",
              fontFamily: defaultTheme_default.typography.fontFamily
            },
            "& .rmdp-header > div": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingX: "8px"
            },
            "& .rmdp-header-values": {
              margin: 0,
              flex: 1,
              textAlign: "left",
              fontSize: "14px",
              "& span:first-child": {
                fontWeight: 600
              },
              "& span:last-child": {
                fontWeight: 600,
                color: "rgba(0, 0, 0, 0.35)"
              }
            },
            "& .rmdp-arrow-container": {
              flex: 0
            },
            "& .rmdp-week-day": {
              fontSize: "12px",
              fontWeight: 600,
              color: "#000",
              width: isMobile ? 36 : 46,
              textAlign: "center",
              height: "32px"
            },
            "& .rmdp-selected": {
              bgcolor: "rgb(25, 111, 130)",
              "&:hover": {
                color: "white !important",
                bgcolor: "rgb(25, 111, 130) !important"
              },
              "& span": {
                bgcolor: "transparent !important",
                boxShadow: "none !important"
              }
            },
            "& .rmdp-day": {
              border: "1px solid #fff",
              width: isMobile ? 36 : 46,
              height: "32px",
              borderRadius: "0px !important",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              "&:hover": {
                bgcolor: "rgba(25, 110, 130, 0.24)"
              },
              "& span": {
                position: "relative",
                top: "0px",
                bottom: "0px",
                left: "0px",
                right: "0px",
                fontSize: "12px",
                "&:hover": {
                  backgroundColor: "transparent !important",
                  color: "inherit !important"
                }
              }
            },
            "& .rmdp-wrapper, & .rmdp-calendar, & .only.rmdp-month-picker": {
              width: "100%"
            },
            // Hide range selection styling
            "& .rmdp-range-hover, & .rmdp-range": {
              backgroundColor: "transparent !important",
              color: "inherit !important"
            },
            "& .rmdp-disabled": {
              color: "rgba(0, 0, 0, 0.25)",
              pointerEvents: "none"
            }
          }
        },
        /* @__PURE__ */ React7.createElement(
          Calendar,
          {
            onlyMonthPicker: true,
            value: value ? new DateObject(value.format("YYYY-MM-DD")) : null,
            onChange: handleMonthChange,
            minDate: minDate && new DateObject(minDate.format("YYYY-MM-DD")),
            maxDate: maxDate && new DateObject(maxDate.format("YYYY-MM-DD")),
            range: false,
            rangeHover: false,
            headerOrder: ["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"],
            weekDays: weekDayLabels,
            highlightToday: false,
            showOtherDays: true,
            disableYearPicker: true,
            renderButton: (direction, handleClick) => /* @__PURE__ */ React7.createElement(
              Button,
              {
                variant: "text",
                onClick: handleClick,
                sx: {
                  backgroundColor: "#F3F3F3",
                  minWidth: 0,
                  padding: "2px 4px",
                  borderRadius: "2px",
                  color: "#000",
                  marginLeft: direction === "right" ? "4px" : 0,
                  "&:hover": {
                    backgroundColor: "#E0E0E0"
                  }
                }
              },
              direction === "right" ? /* @__PURE__ */ React7.createElement(ChevronRight, { fontSize: "small" }) : /* @__PURE__ */ React7.createElement(ChevronLeft, { fontSize: "small" })
            )
          }
        )
      ),
      showClearButton && /* @__PURE__ */ React7.createElement(Box, { sx: { display: "flex", justifyContent: "center", mt: 1 } }, /* @__PURE__ */ React7.createElement(
        Button,
        {
          variant: "text",
          color: "primary",
          size: "small",
          onClick: handleClear
        },
        "Clear"
      ))
    ),
    showApplyBtn && /* @__PURE__ */ React7.createElement(
      ApplyCancel_default,
      {
        handleApplyClick: () => handleApplyMonth("apply"),
        handleCancelClick: handleCancel,
        isChanged: showApplyBtn,
        changedLabel: value ? value.format("MMM YYYY") : "",
        rootSx: {
          paddingBottom: "16px"
        }
      }
    )
  ), /* @__PURE__ */ React7.createElement(
    Button,
    {
      variant: "text",
      size: "small",
      onClick: (e) => {
        setAnchorEl(e.currentTarget);
      },
      startIcon: /* @__PURE__ */ React7.createElement(
        DateRangeIcon,
        {
          sx: { width: "12px", height: "12px", color: "black" }
        }
      ),
      endIcon: /* @__PURE__ */ React7.createElement(ExpandMoreIcon, { sx: { width: "16px", height: "16px" } }),
      sx: __spreadValues({
        padding: "7px 8px",
        color: "#000",
        backgroundColor: "#F3F3F3",
        "& .MuiButton-startIcon": { marginLeft: 0 },
        "& .MuiButton-endIcon": { marginRight: 0 },
        "&:hover": { backgroundColor: "#E4E4E4" },
        "&.Mui-disabled": { bgcolor: "#F3F3F3" }
      }, rootButtonSx),
      disabled
    },
    /* @__PURE__ */ React7.createElement(Typography, { fontSize: "12px", color: "black" }, renderValue ? renderValue(value) : propsValue ? propsValue.format("MMM, YYYY") : `Select ${label ? label : "Month"}`)
  )));
}
function CustomChip(props) {
  return /* @__PURE__ */ React7.createElement(
    Box,
    {
      component: props.component,
      onClick: props.onClick,
      sx: __spreadValues({
        display: "inline-block",
        px: "4px",
        py: "2px",
        borderRadius: "4px",
        backgroundColor: "#727D73",
        color: "#FFF"
      }, props.sx)
    },
    props.children
  );
}

// src/components/Datetime/MonthRangePicker/MonthRangePicker.tsx
function MonthRangePicker(props) {
  var _a, _b, _c, _d;
  const {
    value: propsValue,
    onChange,
    disabled,
    minDate,
    maxDate,
    renderValue,
    label,
    showClearButton,
    showQuarterSelect,
    showLastMonthSelect,
    optionsLastMonthSelect,
    rootButtonSx,
    disableScrollLock
  } = props;
  const [anchorEl, setAnchorEl] = React7.useState(null);
  const [value, setValue] = React7.useState({
    start: (propsValue == null ? void 0 : propsValue.start) || null,
    end: (propsValue == null ? void 0 : propsValue.end) || null
  });
  const isMobile = useMediaQuery(defaultTheme_default.breakpoints.down("sm"));
  const quarterOptions = React7.useMemo(() => {
    const quarters = [];
    for (let i = 1; i <= 4; i++) {
      const start = moment2(maxDate).subtract(i, "quarters").startOf("quarters");
      const end = moment2(maxDate).subtract(i, "quarters").endOf("quarters");
      if (minDate && start.isBefore(minDate)) {
        continue;
      }
      quarters.push({ start, end });
    }
    return quarters;
  }, [minDate, maxDate]);
  const lastMonthOptions = React7.useMemo(() => {
    if (optionsLastMonthSelect) {
      return optionsLastMonthSelect;
    }
    const months = [];
    const lastMonths = [3, 6, 12];
    for (let i = 0; i < lastMonths.length; i++) {
      const startDate = moment2(maxDate).subtract(lastMonths[i], "months").startOf("months");
      const endDate = moment2(maxDate).subtract(lastMonths[i], "months").endOf("months");
      const startDateInRange = dateInRange({
        date: startDate,
        startDate: minDate,
        endDate: maxDate
      });
      const endDateInRange = dateInRange({
        date: endDate,
        startDate: minDate,
        endDate: maxDate
      });
      if (startDateInRange || endDateInRange) {
        months.push(lastMonths[i]);
      }
    }
    return months;
  }, [minDate, maxDate, optionsLastMonthSelect]);
  const { canShowClearButton, canShowLastMonthSelect, canShowQuarterSelect } = React7.useMemo(() => {
    return {
      canShowClearButton: showClearButton,
      canShowLastMonthSelect: showLastMonthSelect && (!optionsLastMonthSelect || optionsLastMonthSelect.length > 0),
      canShowQuarterSelect: showQuarterSelect && quarterOptions.length > 0
    };
  }, [
    showClearButton,
    showLastMonthSelect,
    optionsLastMonthSelect,
    showQuarterSelect,
    quarterOptions
  ]);
  React7.useEffect(() => {
    setValue({
      start: (propsValue == null ? void 0 : propsValue.start) || null,
      end: (propsValue == null ? void 0 : propsValue.end) || null
    });
  }, [propsValue]);
  const showApplyBtn = React7.useMemo(() => {
    const propsStart = get$1(propsValue, "start", null);
    const localStart = get$1(value, "start", null);
    const propsEnd = get$1(propsValue, "end", null);
    const localEnd = get$1(value, "end", null);
    if (!localStart || !localEnd) return false;
    if (propsStart && propsEnd && localStart && localEnd && propsStart.isSame(localStart) && propsEnd.isSame(localEnd))
      return false;
    return true;
  }, [value, propsValue]);
  const handleDateRangeChange = (newDateRange) => {
    if (newDateRange.length === 2) {
      setValue({
        start: moment2(newDateRange[0].format("YYYY-MM-DD")),
        end: moment2(newDateRange[1].format("YYYY-MM-DD"))
      });
    }
  };
  const handleApplyDateRange = (newDateRange, type) => {
    var _a2, _b2;
    const tempValue = newDateRange ? __spreadValues({}, newDateRange) : __spreadValues({}, value);
    tempValue.start = (_a2 = tempValue.start) == null ? void 0 : _a2.startOf("months");
    tempValue.end = (_b2 = tempValue.end) == null ? void 0 : _b2.endOf("months");
    onChange(tempValue, type);
    setAnchorEl(null);
  };
  const handleCancel = () => {
    setAnchorEl(null);
    setValue(__spreadValues({}, propsValue));
  };
  return /* @__PURE__ */ React7.createElement(ErrorBoundary_default, { componentName: "DateRangePicker" }, /* @__PURE__ */ React7.createElement(ThemeProvider, null, /* @__PURE__ */ React7.createElement(
    Popover,
    {
      id: "date-range-popover",
      anchorEl,
      open: Boolean(anchorEl),
      onClose: handleCancel,
      marginThreshold: 20,
      disableScrollLock,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React7.createElement(
      Box,
      {
        sx: {
          padding: isMobile ? "8px" : "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          boxSizing: "border-box",
          maxWidth: isMobile ? 282 : 368,
          minWidth: isMobile ? void 0 : 356,
          "& .rmdp-header": {
            marginTop: "0px"
          }
        }
      },
      /* @__PURE__ */ React7.createElement(
        CalendarRangeComp_default,
        {
          onlyMonthPicker: true,
          value: [
            new DateObject((_a = value.start) == null ? void 0 : _a.format("YYYY-MM-DD")),
            new DateObject((_b = value.end) == null ? void 0 : _b.format("YYYY-MM-DD"))
          ],
          onChange: handleDateRangeChange,
          minDate: minDate && new DateObject(minDate.format("YYYY-MM-DD")),
          maxDate: maxDate && new DateObject(maxDate.format("YYYY-MM-DD")),
          rootSx: {
            "& .rmdp-wrapper, & .rmdp-calendar, & .only.rmdp-month-picker": {
              width: "100%"
            }
          }
        }
      ),
      (canShowQuarterSelect || canShowLastMonthSelect || canShowClearButton) && /* @__PURE__ */ React7.createElement(Divider, { sx: { mb: "8px" } }),
      (canShowQuarterSelect || canShowLastMonthSelect) && /* @__PURE__ */ React7.createElement(Typography, { fontSize: "12px", color: "#000" }, "or\xA0", /* @__PURE__ */ React7.createElement("b", null, "Choose one of the options")),
      canShowQuarterSelect && /* @__PURE__ */ React7.createElement(
        Box,
        {
          sx: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "5px"
          }
        },
        quarterOptions.map((quarter, index) => {
          return /* @__PURE__ */ React7.createElement(
            CustomChip,
            {
              key: `quarter-${index}`,
              sx: { cursor: "pointer" },
              onClick: () => {
                handleApplyDateRange(quarter, "quarter");
              }
            },
            /* @__PURE__ */ React7.createElement(Typography, { sx: { fontSize: "12px", color: "inherit" } }, `${quarter.start.format("MMM YYYY")} - ${quarter.end.format("MMM YYYY")}`)
          );
        })
      ),
      canShowLastMonthSelect && /* @__PURE__ */ React7.createElement(
        Box,
        {
          sx: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "5px"
          }
        },
        lastMonthOptions.map((month, index) => {
          return /* @__PURE__ */ React7.createElement(
            CustomChip,
            {
              key: `last-month-${index}`,
              sx: { cursor: "pointer" },
              onClick: () => {
                const lastMonthRange = getLastMonthRange(
                  month,
                  minDate,
                  maxDate
                );
                handleApplyDateRange(lastMonthRange, "last_month");
              }
            },
            /* @__PURE__ */ React7.createElement(Typography, { sx: { fontSize: "12px", color: "inherit" } }, "Last ", month, " ", pluralize("month", month))
          );
        })
      ),
      /* @__PURE__ */ React7.createElement(
        QuickSelect_default,
        {
          handleApplyDateRange: (val) => handleApplyDateRange(val, "clear"),
          minDate,
          maxDate,
          showClearButton
        }
      )
    ),
    showApplyBtn && /* @__PURE__ */ React7.createElement(
      ApplyCancel_default,
      {
        handleApplyClick: () => handleApplyDateRange(void 0, "apply"),
        handleCancelClick: handleCancel,
        isChanged: showApplyBtn,
        changedLabel: `${(_c = value.start) == null ? void 0 : _c.format(
          "MMM YYYY"
        )} - ${(_d = value.end) == null ? void 0 : _d.format("MMM YYYY")}`,
        rootSx: {
          paddingBottom: "16px"
        }
      }
    )
  ), /* @__PURE__ */ React7.createElement(
    Button,
    {
      variant: "text",
      size: "small",
      onClick: (e) => {
        setAnchorEl(e.currentTarget);
      },
      startIcon: /* @__PURE__ */ React7.createElement(
        DateRangeIcon,
        {
          sx: { width: "12px", height: "12px", color: "black" }
        }
      ),
      endIcon: /* @__PURE__ */ React7.createElement(ExpandMoreIcon, { sx: { width: "16px", height: "16px" } }),
      sx: __spreadValues({
        padding: "7px 8px",
        color: "#000",
        backgroundColor: "#F3F3F3",
        "& .MuiButton-startIcon": { marginLeft: 0 },
        "& .MuiButton-endIcon": { marginRight: 0 },
        "&:hover": { backgroundColor: "#E4E4E4" },
        "&.Mui-disabled": { bgcolor: "#F3F3F3" }
      }, rootButtonSx),
      disabled
    },
    /* @__PURE__ */ React7.createElement(Typography, { fontSize: "12px", color: "black" }, renderValue ? renderValue(value) : propsValue && propsValue.start && propsValue.end ? `${propsValue.start.format(
      "MMM, YYYY"
    )} to ${propsValue.end.format("MMM, YYYY")}` : `Select ${label ? label : "Date Range"}`)
  )));
}

// src/utils/route.util.ts
var formatRoute = (route, stripQueryParams = true) => {
  let formattedRoute = route;
  if (!route.startsWith("/")) {
    formattedRoute = `/${route}`;
  }
  if (formattedRoute.endsWith("/")) {
    formattedRoute = formattedRoute.slice(0, -1);
  }
  if (stripQueryParams && formattedRoute.includes("?")) {
    formattedRoute = formattedRoute.split("?")[0];
  }
  return formattedRoute;
};
function useKeyboardShortcut(options, callback, enabled = true) {
  const handleKeyDown = useCallback(
    (event) => {
      var _a, _b, _c, _d, _e;
      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
      const modifierMatch = isMac ? event.metaKey === ((_b = (_a = options.metaKey) != null ? _a : options.ctrlKey) != null ? _b : false) : event.ctrlKey === ((_c = options.ctrlKey) != null ? _c : false);
      const shiftMatch = event.shiftKey === ((_d = options.shiftKey) != null ? _d : false);
      const altMatch = event.altKey === ((_e = options.altKey) != null ? _e : false);
      const keyMatch = event.key.toLowerCase() === options.key.toLowerCase();
      if (keyMatch && modifierMatch && shiftMatch && altMatch) {
        if (options.preventDefault !== false) {
          event.preventDefault();
        }
        callback();
      }
    },
    [callback, options]
  );
  useEffect(() => {
    if (!enabled) return;
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown, enabled]);
}
function scoreItem(item, query) {
  return scoreText(query, {
    primary: item.title,
    secondary: item.parentLabel,
    tertiary: item.category
  });
}
function useLocalSearch(items, query, maxResults = 20) {
  return useMemo(() => {
    if (!query.trim()) {
      return items.slice(0, maxResults);
    }
    const scored = items.map((item) => ({
      item,
      score: scoreItem(item, query)
    })).filter(({ score }) => score > 0).sort((a, b) => b.score - a.score).slice(0, maxResults);
    return scored.map(({ item }) => item);
  }, [items, query, maxResults]);
}

// src/utils/error/index.ts
var error_default = ErrorBoundary_default;

export { AggregateCard_default as AggregateCard, ConfirmDialog_default as ConfirmDialog, ControlledTextField, error_default as ErrorBoundary, MonthPicker, MonthRangePicker, TimePicker_default as TimePicker, formatRoute, useKeyboardShortcut, useLocalSearch };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map